/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto } from '../models/Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyLogoService {

    /**
     * @param formData 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCompanyLogoSaveCompanyLogo(
formData?: {
CompanyLogo: Blob;
},
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/company-logo/save-company-logo',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCompanyLogoCompanyLogo(): CancelablePromise<Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/company-logo/company-logo',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppCompanyLogoCompanyLogo(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/company-logo/company-logo',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
